/**
 * Test ID utilities for FileUpload component
 *
 * Pattern: All test IDs are generated via named setter functions.
 * This ensures consistency between components and tests.
 */

import { generateTestId } from "@client-shared";

/**
 * Generate test ID for the FileUpload container
 * @param identifier - FileUpload identifier (will be converted to kebab-case)
 * @returns Test ID string
 */
export const setFileUploadTestId = (identifier: string): string =>
  generateTestId("FileUpload", identifier.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for Thumbnail elements
 * @param identifier - Thumbnail identifier (will be converted to kebab-case)
 * @returns Test ID string
 */
export const setFileUploadThumbnailTestId = (identifier: string): string =>
  generateTestId("FileUploadThumbnail", identifier.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for dropzone area
 * @param identifier - Dropzone identifier (will be converted to kebab-case)
 * @returns Test ID string
 */
export const setFileUploadDropzoneTestId = (identifier: string): string =>
  generateTestId("FileUploadDropzone", identifier.replace(/\s+/g, "-").toLowerCase());
